export default __webpack_public_path__ + "static/angieslist-a8aee3417fd865ddaeb3904a6efd0d0c.svg";